import * as yup from "yup";

const yesterdayDate = new Date();
yesterdayDate.setDate(yesterdayDate.getDate() - 2);

export const updateDueDateSchema = yup.object().shape({
  datetime: yup
    .date()
    .min(yesterdayDate, "Past dates are not allowed")
    .required("Date and Time is required"),
});
